<template>
  <div class="trackpage">
    <div class="track_title">{{ $t('home.track.title') }}</div>
    <div class="track_text">{{ $t('home.track.text') }}</div>
    <div class="track_list show">
      <div class="track_li">
        <img class="track_li_img" src="../assets/track/img1.png" alt="">
        <div class="track_li_desc">
          <div class="desc_title">{{ $t('home.track.block1_title') }}</div>
          <div class="desc_text">{{ $t('home.track.block1_text') }}</div>
        </div>
      </div>
      <div class="track_li">
        <img class="track_li_img" src="../assets/track/img2.png" alt="">
        <div class="track_li_desc">
          <div class="desc_title">{{ $t('home.track.block2_title') }}</div>
          <div class="desc_text">{{ $t('home.track.block2_text') }}</div>
        </div>
      </div>
      <div class="track_li">
        <img class="track_li_img" src="../assets/track/img3.png" alt="">
        <div class="track_li_desc">
          <div class="desc_title">{{ $t('home.track.block3_title') }}</div>
          <div class="desc_text">{{ $t('home.track.block3_text') }}</div>
        </div>
      </div>
      <div class="track_li">
        <img class="track_li_img" src="../assets/track/img4.png" alt="">
        <div class="track_li_desc">
          <div class="desc_title">{{ $t('home.track.block4_title') }}</div>
          <div class="desc_text">{{ $t('home.track.block4_text') }}</div>
        </div>
      </div>
    </div>
    <div class="track_list hide">
      <div class="track_li">
        <div class="track_li_top">
          <img class="track_li_img" src="../assets/track/img1.png" alt="">
          <div class="desc_title">{{ $t('home.track.block1_title') }}</div>
        </div>
        <div class="track_li_desc">
          <div class="desc_text">{{ $t('home.track.block1_text') }}</div>
        </div>
      </div>
      <div class="track_li">
        <div class="track_li_top">
          <img class="track_li_img" src="../assets/track/img2.png" alt="">
          <div class="desc_title">{{ $t('home.track.block2_title') }}</div>
        </div>
        <div class="track_li_desc">
          <div class="desc_text">{{ $t('home.track.block2_text') }}</div>
        </div>
      </div>
      <div class="track_li">
        <div class="track_li_top">
          <img class="track_li_img" src="../assets/track/img3.png" alt="">
          <div class="desc_title">{{ $t('home.track.block3_title') }}</div>
        </div>
        <div class="track_li_desc">
          <div class="desc_text">{{ $t('home.track.block3_text') }}</div>
        </div>
      </div>
      <div class="track_li">
        <div class="track_li_top">
          <img class="track_li_img" src="../assets/track/img4.png" alt="">
          <div class="desc_title">{{ $t('home.track.block4_title') }}</div>
        </div>
        <div class="track_li_desc">
          <div class="desc_text">{{ $t('home.track.block4_text') }}</div>
        </div>
      </div>
    </div>
    <div class="track_table">
      <div class="table_li">
        <div class="table_li_text bgcolor3 width1">{{ $t('home.track.table.table1_text1') }}</div>
        <div class="table_li_text bgcolor1 width2">{{ $t('home.track.table.table1_text2') }}</div>
        <div class="table_li_text bgcolor1 width2">{{ $t('home.track.table.table1_text3') }}</div>
        <div class="table_li_text bgcolor1 width2">{{ $t('home.track.table.table1_text4') }}</div>
      </div>
      <div class="table_li">
        <div class="table_li_text bgcolor1 width1">{{ $t('home.track.table.table2_text1') }}</div>
        <div class="table_li_text bgcolor2 width2">{{ $t('home.track.table.table2_text2') }}</div>
        <div class="table_li_text bgcolor2 width2">{{ $t('home.track.table.table2_text3') }}</div>
        <div class="table_li_text bgcolor2 width2">{{ $t('home.track.table.table2_text4') }}</div>
      </div>
      <div class="table_li">
        <div class="table_li_text bgcolor1 width1">{{ $t('home.track.table.table3_text1') }}</div>
        <div class="table_li_text bgcolor2 width2">{{ $t('home.track.table.table3_text2') }}</div>
        <div class="table_li_text bgcolor2 width2">{{ $t('home.track.table.table3_text3') }}</div>
        <div class="table_li_text bgcolor2 width2">{{ $t('home.track.table.table3_text4') }}</div>
      </div>
      <div class="table_li">
        <div class="table_li_text bgcolor1 width1">{{ $t('home.track.table.table4_text1') }}</div>
        <div class="table_li_text bgcolor2 width2">{{ $t('home.track.table.table4_text2') }}</div>
        <div class="table_li_text bgcolor2 width2">{{ $t('home.track.table.table4_text3') }}</div>
        <div class="table_li_text bgcolor2 width2">{{ $t('home.track.table.table4_text4') }}</div>
      </div>
      <div class="table_li">
        <div class="table_li_text bgcolor1 width1">{{ $t('home.track.table.table5_text1') }}</div>
        <div class="table_li_text bgcolor2 width2">{{ $t('home.track.table.table5_text2') }}</div>
        <div class="table_li_text bgcolor2 width2">{{ $t('home.track.table.table5_text3') }}</div>
        <div class="table_li_text bgcolor2 width2">{{ $t('home.track.table.table5_text4') }}</div>
      </div>
      <div class="table_li">
        <div class="table_li_text bgcolor1 width1">{{ $t('home.track.table.table6_text1') }}</div>
        <div class="table_li_text bgcolor2 width2">{{ $t('home.track.table.table6_text2') }}</div>
        <div class="table_li_text bgcolor2 width2">{{ $t('home.track.table.table6_text3') }}</div>
        <div class="table_li_text bgcolor2 width2">{{ $t('home.track.table.table6_text4') }}</div>
      </div>
    </div>
    <div class="track_btns">
      <a class="track_btn" href="https://www.deeplink.cloud/software" target="_blank">
        <img class="icon" src="../assets/track/icon1.png" alt="">
        <p>{{ $t('home.track.btn1') }}</p>
      </a>
      <a class="track_btn" href="https://www.deeplink.cloud/" target="_blank">
        <img class="icon" src="../assets/track/icon2.png" alt="">
        <p>{{ $t('home.track.btn2') }}</p>
      </a>
      <a class="track_btn" href="https://www.deeplink.cloud#team" target="_blank">
        <img class="icon" src="../assets/track/icon3.png" alt="">
        <p>{{ $t('home.track.btn3') }}</p>
      </a>
      <a class="track_btn" href="https://www.deeplink.cloud#economic" target="_blank">
        <img class="icon" src="../assets/track/icon4.png" alt="">
        <p>{{ $t('home.track.btn4') }}</p>
      </a>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  import { defineComponent, ref, onMounted ,computed } from "vue";
  import { useI18n } from "vue-i18n";
  import { useStore } from "vuex"
  export default defineComponent({
    name: 'trackpage',
    setup() {
      const { t, locale } = useI18n()
      const store = useStore()
      let lan = computed(() => store.state.lan)
      return {
        lan,
      };
    }
  })
</script>

<style scoped lang="scss">
.trackpage {
  width: 1200px;
  padding: 30px 40px;
  border-radius: 20px;
  margin: 0 auto 60px;
  box-sizing: border-box;
  background: linear-gradient(250.82deg, rgba(47, 67, 55, 0.544) 4.73%, rgba(46, 81, 60, 0.24) 95.83%);
  .show {
    display: block;
  }
  .hide {
    display: none !important;
  }
  .track_title {
    font-size: 30px;
    font-weight: 600;
    line-height: 40px;
    text-align: center;
    margin-bottom: 8px;
    letter-spacing: 0.05em;
    color: rgba(3, 255, 145, 1);
  }
  .track_text {
    font-size: 24px;
    font-weight: 600;
    line-height: 30px;
    text-align: center;
    margin-bottom: 30px;
    letter-spacing: 0.05em;
    color: rgba(3, 255, 145, 1);
  }
  .track_list {
    width: 100%;
    display: flex;
    margin-bottom: 30px;
    flex-direction: column;
    .track_li {
      width: 100%;
      display: flex;
      padding: 15px 22px;
      margin-bottom: 12px;
      align-items: center;
      border-radius: 16px;
      box-sizing: border-box;
      justify-content: space-between;
      background: rgba(54, 63, 94, 0.3);
      &:last-child {
        margin-bottom: 0;
      }
      .track_li_img {
        width: 80px;
        height: 80px;
        margin-right: 22px;
      }
      .track_li_desc {
        flex: 1;
        .desc_title {
          font-size: 20px;
          font-weight: 600;
          line-height: 27px;
          letter-spacing: 0em;
          color: rgba(255, 255, 255, 0.88);
        }
        .desc_text {
          font-size: 14px;
          font-weight: 500;
          line-height: 24px;
          letter-spacing: 0em;
          color: rgba(255, 255, 255, 0.68);
        }
      }
    }
  }
  .track_table {
    width: 100%;
    .table_li {
      display: flex;
      margin-bottom: 4px;
      justify-content: space-between;
      .table_li_text {
        height: 38px;
        padding: 2px 5px;
        font-size: 12px;
        line-height: 1.05;
        text-align: center;
        letter-spacing: 0em;
        align-items: center;
        display: inline-flex;
        box-sizing: border-box;
        justify-content: center;
      }
      .bgcolor1 {
        color: #fff;
        font-weight: 500;
        background: rgba(54, 63, 94, 0.8);
      }
      .bgcolor2 {
        font-weight: 400;
        color: rgba(255, 255, 255, 0.72);
        background: rgba(54, 63, 94, 0.24);
      }
      .bgcolor3 {
        font-weight: 600;
        color: rgba(43, 179, 106, 0.88);
        background: rgba(54, 63, 94, 0.24);
      }
      .width1 {
        width: 155px;
      }
      .width2 {
        width: 317px;
      }
    }
  }
  .track_btns {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-top: 30px;
    align-items: center;
    justify-content: space-between;
    .track_btn {
      width: 255px;
      height: 50px;
      cursor: pointer;
      border-radius: 25px;
      align-items: center;
      display: inline-flex;
      text-decoration: none;
      justify-content: center;
      background: rgba(41, 159, 102, 1);
      .icon {
        width: 22px;
        height: 22px;
        margin-right: 10px;
      }
      p {
        color: #fff;
        font-size: 16px;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: 0em;
      }
    }
  }
}



@media screen and (max-width: 1200px) {
  .trackpage {
    width: 90%;
    .show {
      display: none !important;
    }
    .hide {
      display: flex !important;
    }
    .track_li {
      display: flex;
      flex-direction: column;
      .track_li_top {
        width: 100%;
        display: flex;
        margin-bottom: 20px;
        align-items: center;
        justify-content: space-between;
        .track_li_img {
          width: 80px;
          height: 80px;
          margin-right: 22px;
        }
        .desc_title {
          flex: 1;
          font-size: 20px;
          font-weight: 600;
          line-height: 27px;
          letter-spacing: 0em;
          color: rgba(255, 255, 255, 0.88);
        }
      }
    }
    .track_table {
      .table_li {
        .table_li_text {
          height: unset;
          padding: 8px 5px;
        }
        .width1 {
          width: 18%;
        }
        .width2 {
          width: 27%;
        }
      }
    }
    .track_btns {
      .track_btn {
        margin-bottom: 10px;
      }
    }
  }
}
</style>